import {IFrameSectionFieldsFragment} from '../../../../__generated__/datocms.types'
import {IFrameSection} from '../types/iframe-section.types'

export function parseIFrameSection(section: IFrameSectionFieldsFragment): IFrameSection {
  return {
    __type: 'IFrameSection',
    id: section.id,
    title: section.title!,
    plot: section.plot,
    source: section.source!,
  }
}
